<template>
  <div>
    <el-popover
      v-model="popoverVisible"
      ref="popover"
      placement="bottom"
      width="400"
      trigger="click">
      <AgencyTreeCore
        v-bind="$attrs"
        v-on="$listeners"
        @selectTreeAgency="selectAgency"
        @checkAgencyLeavesCore="checkAgencyLeaves"
        @checkAgenciesCore="checkAgencies"
        ref="treeCore"
      ></AgencyTreeCore>
    </el-popover>
    <el-button v-popover:popover type="text">{{text}}</el-button>
  </div>
</template>

<script>
  /*
   * this.$refs.tree.setAgency([]); 设置初始选中
   * checkAgencyLeaves 只包含子节点
   * checkAgencies 包含父节点
  */
  import AgencyTreeCore from './AgencyTreeCore.vue';
  import _ from 'lodash';

  export default {
    components: {
      AgencyTreeCore
    },
    inheritAttrs: false,
    data () {
      return {
        popoverVisible: false,
        text: '请选择组织机构'
      };
    },
    methods: {
      selectAgency (agency) {
        if (agency) {
          this.popoverVisible = false;
          this.text = `已选择机构：${agency.name}`;
          this.$emit('selectAgency', agency);
        } else {
          this.popoverVisible = false;
          this.text = '请选择组织机构';
        }
      },
      checkAgencies (agencies) {
        this.setAgencyName('checkAgencies', agencies);
        let storeList = _.filter(agencies, (item) => {
          // 过滤总店分公司
          return item.type !== 1 && item.type !== 2;
        });
        let checkedNum = 0;
        if (!!this.$attrs.selectHQ) {   //如果父子不关联，则计算节点数包含总公司和分公司，否则过滤掉
          checkedNum = agencies.length;
        } else {
          checkedNum = storeList.length;
        }
        switch (checkedNum) {
          case 0:
            this.text = '请选择组织机构';
            break;
          case 1:
            this.text = `已选择门店：${agencies[0].name}`;
            break;
          default:
            this.text = `已选择 ${checkedNum} 家门店`;
        }
      },
      checkAgencyLeaves (agencyLeaves) {
        this.setAgencyName('checkAgencyLeaves', agencyLeaves);
        let checkedNum = agencyLeaves.length;
        switch (checkedNum) {
          case 0:
            this.text = '请选择组织机构';
            break;
          case 1:
            this.text = `已选择门店：${agencyLeaves[0].name}`;
            break;
          default:
            this.text = `已选择 ${checkedNum} 家门店`;
        }
      },
      setAgencyName (type, agencies) {
        let selectedAgencies = agencies.map((item) => {
          return item.id;
        });
        let selectedHotelId = agencies.map((item) => {
          if (item.hotelId === 0) {
            return item.id;
          } else {
            return item.hotelId;
          }
        });
        let selectedHotelType = agencies.map((item) => {
          if (item.hotelId === 0) {
            return {
              id:item.id,
              type:item.type
            };
          } else {
            return {
              id:item.hotelId,
              type:item.type
            };
          }
        });

        this.$emit(type, selectedAgencies);   //返回选择的门店id
        this.$emit(type +'HotelId' , selectedHotelId);   //返回选择的门店hotelid
        this.$emit(type +'HotelType' , selectedHotelType);   //返回选择的门店hotelid及type
      },
      setAgency (agencies, useHotelId = false) {
        this.$refs.treeCore.setAgency(agencies, useHotelId);
      },
      setDisabled (disabledList = []) {
        this.$refs.treeCore.setDisabled(disabledList);
      }
    },
    watch: {
      popoverVisible (curVal) {
        if (!curVal) {
          this.$refs.treeCore.filterText = '';
        }
      }
    }
  };
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// AgencyTree.vue?0e8999d4